import apiClient from '../apiClient';

export type ReqGetStories = {
  lastId?: number;
};

export interface StoryBaseContent {
  id: number;
  title: string;
  content: string;
  categoryId: number;
  categoryName: string;
  villageName: string;
  representativeImageUrl: string;
  viewCount: number;
  startDate: string; // ISO 형식의 날짜 문자열
  favYn: boolean;
  thumbnailUrl: string;
}

export type ResGetStories = SlotPaginationResponse<StoryBaseContent>;

const getStories = async ({ lastId }: ReqGetStories): Promise<ResGetStories> => {
  const params = new URLSearchParams();
  if (lastId !== undefined) {
    params.append('lastId', lastId.toString());
  }
  params.append('platformType', 'GROUND');
  const { data } = await apiClient.get<ResGetStories>(`/app/stories?${params.toString()}`);

  return data;
};

export default getStories;
